import React, { useState, useEffect } from 'react'
import Styles from './CreateAccountPage.module.css'
import { IFButton, IFText, IFTextInput, IFLoadingIndicator } from 'Components'
import { Colors, Images } from 'Theme'
import AuthSelectors from 'Stores/Auth/Selectors'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import validator from 'validator'
import OperatorUserActions from 'Stores/OperatorUser/Actions'
import history from 'history/browser'
import OperatorUserSelectors from 'Stores/OperatorUser/Selectors'
import RequestState from 'Enums/RequestState'
import InfinityEnums from 'Enums/InfinityEnums'
import Link from '@mui/material/Link'
import { useNavigate } from 'react-router-dom'

const CreateAccountPage = ({
  isLoginLoading,
  fetchInviteOperatorUser,
  inviteOperatorUser,
  fetchInviteOperatorUserRequestState,
  createOperatorUser,
  createOperatorUserRequestState,
  inviteOperatorUserStatus,
}) => {
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [nameError, setNameError] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [confirmPasswordError, setConfirmPasswordError] = useState('')
  const [canRegister, setCanRegister] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    const slashArray = history.location.pathname.split('/')
    const inviteOperatorUserId = slashArray[slashArray.length - 1]
    if (inviteOperatorUserId && inviteOperatorUserId.match(/^[0-9a-fA-F]{24}$/))
      fetchInviteOperatorUser(inviteOperatorUserId)
  }, [])

  const ResetPasswords = () => {
    setPasswordError('')
    setConfirmPasswordError('')
  }

  const handleRegisterClick = () => {
    let operatorUser = {
      name: name,
      password: password,
      email: inviteOperatorUser.email,
      permissions: inviteOperatorUser.permissions,
      operator: inviteOperatorUser.operator,
      inviteId: inviteOperatorUser._id,
    }
    createOperatorUser(operatorUser)
  }

  useEffect(() => {
    if (createOperatorUserRequestState === RequestState.SUCCEEDED) {
      navigate('/auth/login')
    }
  }, [createOperatorUserRequestState])

  const minLength = 12
  const hasLowercase = /[a-z]/
  const hasUppercase = /[A-Z]/
  const hasNumber = /[0-9]/
  const hasSymbol = /[^A-Za-z0-9]/

  const validatePassword = (password, confirmPassword, checkMatch) => {
    if (password.length === 0) return t('CreateAccountPage.Required')
    if (password.length < minLength) return t('CreateAccountPage.PasswordError')
    if (!hasLowercase.test(password))
      return t('CreateAccountPage.PasswordLowercase')
    if (!hasUppercase.test(password))
      return t('CreateAccountPage.PasswordUppercase')
    if (!hasNumber.test(password)) return t('CreateAccountPage.PasswordNumber')
    if (!hasSymbol.test(password)) return t('CreateAccountPage.PasswordSymbol')
    if (checkMatch && password !== confirmPassword)
      return t('CreateAccountPage.ConfirmPasswordError')
    return ''
  }

  return (
    <div>
      <div
        className={Styles.backgroundImage}
        style={{
          backgroundImage: `url(${Images.createAccountBackground})`,
        }}
      />
      <div
        className={Styles.loginwrapper}
        style={{
          backgroundColor: Colors.CreateAccountBackgroundColor,
          boxShadow: `0px 0px 4px ${Colors.CreateAccountBackgroundShadow}`,
        }}
      >
        <div
          className={
            fetchInviteOperatorUserRequestState === RequestState.LOADING ||
            inviteOperatorUserStatus === InfinityEnums.InvitationStatus.ACCEPTED
              ? Styles.LogoLoading
              : Styles.Logo
          }
        >
          <img className={Styles.img} src={Images.infinity} alt="logo" />
        </div>
        {fetchInviteOperatorUserRequestState === RequestState.LOADING ? (
          <div className={Styles.LoadingIndicator}>
            <IFLoadingIndicator />
          </div>
        ) : inviteOperatorUserStatus ===
          InfinityEnums.InvitationStatus.PENDING ? (
          <div className={Styles.inputContainer}>
            <div>
              <div className={Styles.titleContainer}>
                <IFText style={{ color: Colors.text }} className={Styles.title}>
                  {t('CreateAccountPage.CreateAccount')}
                </IFText>
              </div>
              <div className={Styles.InputFieldContainer}>
                <IFText style={{ color: Colors.text }} className={Styles.label}>
                  {t('CreateAccountPage.EmailAddress')}
                </IFText>

                <IFText style={{ color: Colors.text }} className={Styles.email}>
                  {inviteOperatorUser.email}
                </IFText>
              </div>
              <div className={Styles.NameContainer}>
                <IFText style={{ color: Colors.text }} className={Styles.label}>
                  {t('CreateAccountPage.Name')}
                </IFText>

                <IFTextInput
                  style={{ caretColor: Colors.primary }}
                  className={Styles.input}
                  isFixed={true}
                  value={name}
                  name="name"
                  type="text"
                  onChange={(e) => {
                    setName(e.target.value)
                    e.target.value.length === 0
                      ? setNameError(t('CreateAccountPage.Required'))
                      : validator.isAlpha(e.target.value, 'en-US', {
                            ignore: ' ',
                          })
                        ? setNameError('')
                        : setNameError(t('CreateAccountPage.NameError'))
                    const register =
                      validator.isAlpha(e.target.value, 'en-US', {
                        ignore: ' ',
                      }) &&
                      validator.isLength(password, { min: 8, max: 100 }) &&
                      validator.equals(password, confirmPassword)
                    setCanRegister(register)
                  }}
                  onBlur={(e) => {
                    e.target.value.length === 0
                      ? setNameError(t('CreateAccountPage.Required'))
                      : validator.isAlpha(e.target.value, 'en-US', {
                            ignore: ' ',
                          })
                        ? setNameError('')
                        : setNameError(t('CreateAccountPage.NameError'))
                    const register =
                      validator.isAlpha(e.target.value, 'en-US', {
                        ignore: ' ',
                      }) &&
                      validator.isLength(password, { min: 8, max: 100 }) &&
                      validator.equals(password, confirmPassword)
                    setCanRegister(register)
                  }}
                  {...(nameError.length > 0 ? { errorText: nameError } : {})}
                />
              </div>
              <div className={Styles.InputFieldContainer}>
                <IFText style={{ color: Colors.text }} className={Styles.label}>
                  {t('CreateAccountPage.Password')}
                </IFText>

                <IFTextInput
                  className={Styles.input}
                  style={{ caretColor: Colors.primary }}
                  isFixed={true}
                  value={password}
                  onChange={(e) => {
                    const value = e.target.value
                    setPassword(value)
                    const error = validatePassword(
                      value,
                      confirmPassword,
                      confirmPassword.length > 0,
                    )
                    setPasswordError(error)
                    const register =
                      validatePassword(value, confirmPassword, true) === '' &&
                      value === confirmPassword
                    setCanRegister(register)
                  }}
                  onBlur={(e) => {
                    const value = e.target.value
                    setPassword(value)
                    const error = validatePassword(
                      value,
                      confirmPassword,
                      confirmPassword.length > 0,
                    )
                    setPasswordError(error)
                    const register =
                      validatePassword(value, confirmPassword, true) === '' &&
                      value === confirmPassword
                    setCanRegister(register)
                  }}
                  type="password"
                  {...(passwordError.length > 0
                    ? { errorText: passwordError }
                    : {})}
                />
              </div>
              <div className={Styles.InputFieldContainer}>
                <IFText style={{ color: Colors.text }} className={Styles.label}>
                  {t('CreateAccountPage.ConfirmPassword')}
                </IFText>

                <IFTextInput
                  className={Styles.input}
                  style={{ caretColor: Colors.primary }}
                  isFixed={true}
                  value={confirmPassword}
                  onChange={(e) => {
                    const value = e.target.value
                    setConfirmPassword(value)
                    const error =
                      validatePassword(value, value, true) ||
                      (value !== password
                        ? t('CreateAccountPage.ConfirmPasswordError')
                        : '')
                    setConfirmPasswordError(error)

                    const register =
                      validatePassword(password, value, true) === '' &&
                      password === value
                    setCanRegister(register)
                  }}
                  onBlur={(e) => {
                    const value = e.target.value
                    setConfirmPassword(value)
                    const error =
                      validatePassword(value, value, true) ||
                      (value !== password
                        ? t('CreateAccountPage.ConfirmPasswordError')
                        : '')
                    setConfirmPasswordError(error)

                    const register =
                      validatePassword(password, value, true) === '' &&
                      password === value
                    setCanRegister(register)
                  }}
                  type="password"
                  {...(confirmPasswordError.length > 0
                    ? { errorText: confirmPasswordError }
                    : {})}
                />
              </div>
            </div>
            <div className={Styles.signIn}>
              <IFButton
                text={t('CreateAccountPage.Register')}
                color={Colors.primary}
                isFill={true}
                size="sm"
                onClick={handleRegisterClick}
                isLoading={
                  createOperatorUserRequestState === RequestState.LOADING ||
                  isLoginLoading
                }
                isDead={!canRegister}
              ></IFButton>
            </div>
          </div>
        ) : inviteOperatorUserStatus ===
          InfinityEnums.InvitationStatus.ACCEPTED ? (
          <div className={Styles.AcceptedText}>
            <div>
              <IFText style={{ color: Colors.text }}>
                {t('CreateAccountPage.AcceptedInvite')}
              </IFText>
            </div>
            <div className={Styles.ClickHere}>
              <IFText
                className={Styles.ClickHereText}
                style={{ color: Colors.text }}
              >
                {t('CreateAccountPage.ToLogin')}
              </IFText>
              <Link
                href="/auth/login"
                variant="body2"
                style={{
                  color: Colors.linkColor,
                  fontSize: '1.1rem',
                }}
                className={Styles.link}
              >
                <IFText className={Styles.ClickHereText}>
                  {t('CreateAccountPage.Here')}
                </IFText>
              </Link>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
function mapDispatchToProps(dispatch) {
  return {
    fetchInviteOperatorUser: (inviteOperatorUserId) =>
      dispatch(
        OperatorUserActions.fetchInviteOperatorUser(inviteOperatorUserId),
      ),
    createOperatorUser: (operatorUser) =>
      dispatch(OperatorUserActions.createOperatorUser(operatorUser)),
  }
}

const mapStateToProps = (state) => ({
  isLoginLoading: AuthSelectors.isOperatorUserLoginLoading(state),
  inviteOperatorUser: OperatorUserSelectors.getInviteOperatorUser(state),
  fetchInviteOperatorUserRequestState:
    OperatorUserSelectors.getFetchInviteOperatorUserRequestState(state),
  createOperatorUserRequestState:
    OperatorUserSelectors.getCreateOperatorUserRequestState(state),
  inviteOperatorUserStatus:
    OperatorUserSelectors.getInviteOperatorUserStatus(state),
})

CreateAccountPage.propTypes = {
  isLoginLoading: PropTypes.bool,
  fetchInviteOperatorUser: PropTypes.func,
  inviteOperatorUser: PropTypes.func,
  fetchInviteOperatorUserRequestState: PropTypes.number,
  createOperatorUser: PropTypes.func,
  createOperatorUserRequestState: PropTypes.number,
  inviteOperatorUserStatus: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccountPage)
